import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropdown", "frame", "result"]
  static values = { url: String, minChars: { type: Number, default: 3 } }

  connect() {
    this.activeIndex = -1
    this.dropdownOpen = false
    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.handleClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside)
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
  }

  focus() {
    const query = this.inputTarget.value.trim()
    if (query.length >= this.minCharsValue) {
      this.showDropdown()
    }
  }

  search() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => {
      const query = this.inputTarget.value.trim()
      if (query.length >= this.minCharsValue) {
        this.frameTarget.src = `${this.urlValue}?q=${encodeURIComponent(query)}`
        this.showDropdown()
      } else {
        this.hideDropdown()
      }
      this.activeIndex = -1
    }, 300)
  }

  navigate(event) {
    if (!this.dropdownOpen) return

    switch (event.key) {
      case "ArrowDown":
        event.preventDefault()
        this.activeIndex = Math.min(this.activeIndex + 1, this.resultTargets.length - 1)
        this.highlightResult()
        break
      case "ArrowUp":
        event.preventDefault()
        this.activeIndex = Math.max(this.activeIndex - 1, 0)
        this.highlightResult()
        break
      case "Enter":
        event.preventDefault()
        if (this.activeIndex >= 0 && this.resultTargets[this.activeIndex]) {
          this.resultTargets[this.activeIndex].click()
        }
        break
      case "Escape":
        this.hideDropdown()
        this.inputTarget.blur()
        break
    }
  }

  selectResult() {
    this.hideDropdown()
  }

  // Private

  showDropdown() {
    this.dropdownTarget.classList.remove("hidden")
    this.dropdownOpen = true
  }

  hideDropdown() {
    this.dropdownTarget.classList.add("hidden")
    this.dropdownOpen = false
    this.activeIndex = -1
    this.clearHighlight()
  }

  highlightResult() {
    this.clearHighlight()
    if (this.activeIndex >= 0 && this.resultTargets[this.activeIndex]) {
      this.resultTargets[this.activeIndex].classList.add("bg-base-200")
      this.resultTargets[this.activeIndex].scrollIntoView({ block: "nearest" })
    }
  }

  clearHighlight() {
    this.resultTargets.forEach(r => r.classList.remove("bg-base-200"))
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideDropdown()
    }
  }
}
